import { CREATE_COURSES_LOADING, CREATE_COURSES_SUCCESS, CREATE_COURSES_ERROR } from "../../../constant/actionTypes";

const createCourseReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_COURSES_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_COURSES_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case CREATE_COURSES_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createCourseReducer;